import { createFileRoute } from '@tanstack/react-router';

import { DesignInspirationsView } from 'src/sections/admin/design-inspirations/design-inspirations-view';

export const Route = createFileRoute('/admin-skidog/design-inspirations/')({
  component: DesignInspirationsPage,
});

function DesignInspirationsPage() {
  return <DesignInspirationsView />;
}
